import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: 'https://16c7ba8ed35b3a9832898947db7f2ecf@o457690.ingest.us.sentry.io/4509000798109696',
  environment: environment.production ? 'production' : environment.develop ? 'develop' : 'test',
  ignoreErrors: [/Http failure response for/],
});

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch(err => console.error(err));
